import { getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';
import { ILogger, ITelemetryHandler, telemetryHandlersConfigurationFacet } from '@ms/items-view';
import {
    AsyncTelemetryHandler,
    WebSharedAriaTelemetryHandler,
    IAppEnvironment,
} from '@ms/telemetry-addon-aria';
import { getParameterStore } from '../store/ParametersStore';
import { getLogicalRing } from 'owa-config';

export { ILogger, ITelemetryHandler };

function getEnvironment(): IAppEnvironment {
    if (process.env.NODE_ENV === 'production') {
        switch (getLogicalRing()) {
            case 'WW':
            case 'FirstRelease':
                return 'prod';
            case 'Microsoft':
                return 'msit' as IAppEnvironment;
            case 'Dogfood':
                return 'sdf' as IAppEnvironment;
            default:
                return 'unknown' as IAppEnvironment;
        }
    } else {
        return 'ppe';
    }
}

async function getTokenForItemsViewConfiguration(): Promise<string> {
    try {
        let [token, tokenPromise] = getAccessTokenforResourceAsLazy(window.location.origin);

        // If token is not returned synchronously, we need to await on the tokenPromise
        if (!token) {
            token = await tokenPromise;
        }

        return token;
    } catch {
        return null;
    }
}

export const itemsViewConfiguration = {
    ...telemetryHandlersConfigurationFacet.pack([
        new AsyncTelemetryHandler(async () => {
            const userAuthToken: string = await getTokenForItemsViewConfiguration();

            return new WebSharedAriaTelemetryHandler({
                userAuthToken,
                clientName: getParameterStore().scenarioName,
                environment: getEnvironment(),
                context: {},
            });
        }),
    ]),
};
